// loanApiSlice.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const loanApiSlice = createApi({
  reducerPath: "loanApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://moneylend.dockyardsoftware.com/" ,
    // baseUrl: "https://localhost:44364/",
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("token");
      if (token) headers.set("authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  tagTypes: ["Loan"],

  endpoints: (builder) => ({
    // Get all loans with complete details (Admin only)
    getAllLoans: builder.query({
      query: () => "Loan/GetAllLoans",
      transformResponse: (response) => {
        return response?.ResultSet || [];
      },
      providesTags: ["Loan"],
    }),

     // Get all active loan products
    getActiveLoanProducts: builder.query({
      query: () => "LoanProduct/GetActiveLoanProducts", // adjust endpoint if needed
      transformResponse: (response) => response?.ResultSet || [],
      providesTags: ["LoanProduct"],
    }),

    // Get loans by borrower
    getLoansByBorrower: builder.query({
      query: (borrowerId) => `Loan/GetLoansByBorrower?borrowerId=${borrowerId}`,

      transformResponse: (response) => {
        return response?.ResultSet || [];
      },
      providesTags: ["Loan"],
    }),

    // Get loan by ID
    getLoanById: builder.query({
      query: (loanId) => `Loan/GetLoan/${loanId}`,
      providesTags: ["Loan"],
    }),

    // Update loan status
    updateLoanStatus: builder.mutation({
      query: ({ loanId, status }) => ({
        url: "Loan/UpdateLoanStatus",
        method: "PUT",
        body: { loanId, status },
      }),
      invalidatesTags: ["Loan"],
    }),

    // Approve loan
    approveLoan: builder.mutation({
      query: (loanId) => ({
        url: `Loan/ApproveLoan/${loanId}`,
        method: "POST",
      }),
      invalidatesTags: ["Loan"],
    }),

    // Reject loan
    rejectLoan: builder.mutation({
      query: (loanId) => ({
        url: `Loan/RejectLoan/${loanId}`,
        method: "POST",
      }),
      invalidatesTags: ["Loan"],
    }),

    // Add new loan
    addLoan: builder.mutation({
      query: (loanData) => ({
        url: "Loan/AddLoan",
        method: "POST",
        body: loanData,
      }),
      invalidatesTags: ["Loan"],
    }),
  }),
});

export const {
  useGetAllLoansQuery,
  useGetActiveLoanProductsQuery,
  useGetLoansByBorrowerQuery,
  useGetLoanByIdQuery,
  useUpdateLoanStatusMutation,
  useApproveLoanMutation,
  useRejectLoanMutation,
  useAddLoanMutation,
} = loanApiSlice;